import { __awaiter, __decorate } from "tslib";
import { injectable } from '@slickdeals/durango/dist/javascript/decorators/injectable';
import Injector, { InjectorScope } from '@slickdeals/durango/dist/javascript/core/injector';
import Modal, { ClassNames as ModalClassNames } from '@slickdeals/blueprint-twig/javascript/components/modal';
import { ClassNames as OverlayClassNames } from '@slickdeals/blueprint-twig/javascript/components/overlay';
import CatalogItem from '@slickdeals/durango/dist/javascript/core/catalogItem';
import { catalogItem } from '@slickdeals/durango/dist/javascript/decorators/catalogItem';
import { mediatable } from '@slickdeals/durango/dist/javascript/decorators/mediatable';
import Logger from '@slickdeals/durango/dist/javascript/utilities/logger';
import { joinLoyalty } from '../../utilities/loyalty';
/* eslint-disable import/extensions */
import { name as CashbackJoinModalContextServiceName } from './cashbackJoinModalContextService';
/** Import styles for all modal states */
import '../../../scss/patterns/cashbackJoinModal/cashbackJoinModal.scss';
export const name = 'CashbackJoinModal';
export var ClassNames;
(function (ClassNames) {
    ClassNames["Default"] = "bp-p-cashbackJoinModal";
    ClassNames["Button"] = "bp-p-cashbackJoinModal_button";
    ClassNames["CountdownContainer"] = "bp-p-cashbackJoinModal_countdown";
    ClassNames["CountdownActive"] = "bp-p-cashbackJoinModal_countdown--active";
    ClassNames["CountdownValue"] = "bp-p-cashbackJoinModal_countdownValue";
})(ClassNames || (ClassNames = {}));
export var MediatedEvents;
(function (MediatedEvents) {
    MediatedEvents["Activate"] = "activate";
})(MediatedEvents || (MediatedEvents = {}));
// Import both modal types as dependencies
export const dependencies = Object.assign({}, Injector.createDependency(CashbackJoinModalContextServiceName, InjectorScope.Factory));
const updateCashbackJoinModalStatus = () => {
    // Save cashbackJoinModal state, we only want to show modal once to user
    localStorage.setItem('cashbackJoinModalData', JSON.stringify({ show: false }));
};
let CashbackJoinModal = class CashbackJoinModal extends CatalogItem {
    constructor(modalService, heap, options) {
        super(options);
        this.modalService = modalService;
        this.heap = heap;
        this.options = options;
    }
    /**
     * Initializes cashback join modal
     */
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            this.modalContent = this.modalService.initModalContext();
            this.modal = new Modal({
                content: this.modalContent,
                isFixed: true,
                closeButton: true,
            });
            // Retrieve local storage data for cashbackJoinModal
            const cashbackJoinModalData = localStorage.getItem('cashbackJoinModalData');
            // If no data exists, proceed to show modal as usual
            if (!cashbackJoinModalData) {
                yield this.showModal();
                // TODO: Clean this up by modifying modal and overlay component by adding hooks, right now need to select x button this way for modal.
                const modalContainer = this.modalContent.closest(`.${ModalClassNames.Default}`);
                const modalCloseButton = modalContainer.querySelector(`.${ModalClassNames.CloseButton}`);
                const overlay = document.querySelector(`.${OverlayClassNames.Default}`);
                // Apply same handler to both modal close button and overlay
                [modalCloseButton, overlay].forEach(element => {
                    element.addEventListener('click', updateCashbackJoinModalStatus);
                });
                const button = this.modalContent.querySelector(`.${ClassNames.Button}`);
                button.addEventListener('click', this.handleClick.bind(this));
            }
        });
    }
    /** Show cashback join modal */
    showModal() {
        return __awaiter(this, void 0, void 0, function* () {
            this.modal.show(true);
            // Fire impression for modal
            try {
                yield this.heap.track('Rewards No Extension - Join Cashback Modal - Impression');
            }
            catch (e) {
                Logger.warn('Error firing heap event');
            }
        });
    }
    /** Hide cashback join modal */
    closeModal() {
        this.modal.hide();
    }
    /**
     * Opts user into loyalty and updates UI state.
     * @param event Click event from CTA on modal button
     */
    handleClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            this.mediate(MediatedEvents.Activate);
            const button = event.target;
            button.disabled = true;
            const result = yield joinLoyalty('dd-cashback-modal');
            if (result.isLoyaltyUser) {
                // Applies data attribute to See Deal button on deal details
                const seeDealCta = document.getElementById('largeBuyNow');
                seeDealCta.setAttribute('data-show-loyalty-outclick-flow', '1');
                button.textContent = 'Cashback Joined';
                const countdownContainer = document.querySelector(`.${ClassNames.CountdownContainer}`);
                countdownContainer.classList.add(`${ClassNames.CountdownActive}`);
                // Counts down 3 seconds and then closes modal
                this.startClosingCountdown();
            }
        });
    }
    /**
     * Trigger a countdown timer that closes modal.
     */
    startClosingCountdown() {
        let countdown = 3;
        const redirectDelay = setInterval(() => {
            if (countdown < 0) {
                clearInterval(redirectDelay);
                this.closeModal();
            }
            else {
                this.modalContent.querySelector(`.${ClassNames.CountdownValue}`).textContent = ` ${countdown.toString()}`;
            }
            countdown -= 1;
        }, 1000);
    }
};
CashbackJoinModal = __decorate([
    injectable(name, dependencies),
    catalogItem(name),
    mediatable(name, Object.values(MediatedEvents))
], CashbackJoinModal);
export default CashbackJoinModal;
